export type OwnBffEnvelope<T> = {
  code: number;
  msg: string;
  data: T;
};

export const isOwnBffEnvelope = <T>(
  value: unknown,
): value is OwnBffEnvelope<T> => {
  if (!value || typeof value !== 'object') return false;
  const record = value as Record<string, unknown>;
  return (
    typeof record.code === 'number' &&
    typeof record.msg === 'string' &&
    'data' in record
  );
};

export const throwIfOwnBffFailed = (value: unknown) => {
  if (!isOwnBffEnvelope(value) || value.code === 0) return;

  const error = new Error(value.msg || '请求失败') as Error & {
    name: string;
    info: {
      errorCode: number;
      errorMessage: string;
      data: unknown;
    };
  };
  error.name = 'BizError';
  error.info = {
    errorCode: value.code,
    errorMessage: value.msg,
    data: value.data,
  };
  throw error;
};

export const unwrapOwnBffData = <T>(value: unknown): T => {
  throwIfOwnBffFailed(value);
  if (isOwnBffEnvelope<T>(value)) {
    return value.data;
  }
  return value as T;
};
